module.exports = __webpack_public_path__ + "static/media/dr.1468a1f3.jpg";